import { postAuthorised } from 'approot/shared/api/auth/auth.http';
import {
  HTTP_202_ACCEPTED,
  HTTP_404_NOT_FOUND,
  PORTFOLIO_TYPE_STUDENT_RESPONSES,
} from 'global/constants';
import { Student } from '../classroom/classroom.constants';

type DownloadStudentPortfolioPdfParams = {
  classId: number | undefined;
  className: string;
  contentId: number;
  sectionIds: string[];
  selectedStudents: Student[];
  showSuccess: (message: string) => void;
  showError: (message: string) => void;
  handleClose: () => void;
  setIsDownloading: (isDownloading: boolean) => void;
};

export const downloadStudentPortfolioPdf = async ({
  classId,
  className,
  contentId,
  sectionIds,
  selectedStudents,
  showSuccess,
  showError,
  handleClose,
  setIsDownloading,
}: DownloadStudentPortfolioPdfParams): Promise<void> => {
  try {
    const response = await postAuthorised({
      path: '/api/download-student-portfolio',
      postJSON: {
        classId,
        className,
        portfolioType: PORTFOLIO_TYPE_STUDENT_RESPONSES,
        students: selectedStudents,
        contentId,
        sectionIds,
      },
    });

    if (response.status === HTTP_202_ACCEPTED) {
      showSuccess("We'll email you the PDF once it's ready");
      handleClose();
      return;
    }

    if (response.status !== 200 || !response.body) {
      if (response.status === HTTP_404_NOT_FOUND) {
        showError('No student responses found for this activity');
        setIsDownloading(false);
        return;
      }
      showError('There was an error preparing the download. Please try again');
      return;
    }

    const pdfBlob = await response.blob();
    if (!pdfBlob || !pdfBlob.size) {
      showError('There was an error preparing the download. Please try again');
      return;
    }
    handleClose();
  } catch {
    showError('There was an error preparing the download. Please try again');
  }
};
